import { Popover } from '@finbeat/react-toolkit';
import { faRemove } from '@fortawesome/free-solid-svg-icons';
import { orderDelete } from 'axios/orderApi';
import useApi from 'hooks/useApi';
import { Trans } from 'react-i18next';

type OrderDeletePopoverProps = {
    orderId: string;
};

const OrderDeletePopover = (props: OrderDeletePopoverProps) => {
    const api = useApi();

    const mutationFunction = () => {
        return orderDelete(api, parseInt(`${props.orderId}`));
    };

    return (
        <Popover
            label={'delete'}
            textStyle={'danger'}
            buttonIcon={faRemove}
            buttonLabel={'BackOfficeDelete'}
            orderId={props.orderId}
            mutationFunction={mutationFunction}
            canSave={true}
            refetchQueryKeys={[['order'], 'orderStatusCount']}
            header={
                <>
                    <Trans i18nKey={'BackOfficeDelete'} /> #{props.orderId}
                </>
            }
        >
            <></>
        </Popover>
    );
};

export default OrderDeletePopover;
